import useScreenSize from "../../../../hooks/useScreenSize";
import { screenSizes } from "../../../../constants";
import { Box, IconButton, Menu } from "@mui/material";
import { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { menuItems } from "./constants";
import InfoIcon from "@mui/icons-material/Info";
import { NotificationPopUp } from "../../../components/NotificationPopUp/NotificationPopUp";
import { useAppSelector } from "../../../../hooks/redux";
import { parseJsonToken } from "../../../../helpers/helper";
import { useAction } from "../../../../hooks/actions";

const AdditionalInfo = () => {
  const { width } = useScreenSize();
  const token = useAppSelector((state) => state.users.token);
  const [permissions, setPermissions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMessage, setopenMessage] = useState(false);
  const { updatePermissions } = useAction();
  const [messageCount, setmessageCount] = useState(0);
  const isSmallDesktop = useScreenSize().width < 1560;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const sx = {
    fontFamily: "var(--INTER)",
    fontWeight: 500,
    fontSize: isSmallDesktop ? "var(--titleBlock)" : "var(--standartVeryLarge)",
    lineHeight: "24px",
    color: "var(--mainText)",
    cursor: "pointer",
    textDecoration: "none",
    textTransform: "none",
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    token && parseJsonToken({ token, setPermissions });
  }, [token, setPermissions]);

  useEffect(() => {
    if (!permissions) return;
    updatePermissions(permissions);
  }, [permissions]);

  if (width <= screenSizes.tablet) {
    return (
      <Box className="header-navbar-text">
        <IconButton aria-expanded={anchorEl} onClick={handleClick} sx={{ color: "var(--main)" }}>
          <InfoIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
          {menuItems
            .filter(({ permission }) => permissions.includes(permission))
            .map(({ id, Component, ...props }) => (
              <MenuItem key={id}>
                <Component messageCount={messageCount} setOpenPopup={setopenMessage} sx={sx} {...props} />
              </MenuItem>
            ))}
        </Menu>
      </Box>
    );
  }

  return (
    <Box className="header-navbar-text">
      <NotificationPopUp customopen={openMessage} setopenMessage={setopenMessage} setmessageCount={setmessageCount} />
      {menuItems
        .filter(({ permission }) => permissions.includes(permission))
        .map(({ id, Component, ...props }) => (
          <Box key={id} sx={sx}>
            <Component messageCount={messageCount} setOpenPopup={setopenMessage} sx={sx} {...props} />
          </Box>
        ))}
    </Box>
  );
};

export default AdditionalInfo;
